import Typography from "@mui/material/Typography";
import Board from "../../misc/Board";
import { DunningColumn } from "./DunningColumn";
import { Money } from "../../misc/Money";
import { BookOutButton } from "../../buttons/BookOutButton";
import { CancelDunningProcessButton } from "../../buttons/CancelDunningProcessButton";
import { useDunningActionDialog } from "../../hooks/useDunningActionDialog";
import { CancelDunningProcessDialog } from "../../dialogs/CancelDunningProcessDialog";
import { BookOutDunningDialog } from "../../dialogs/BookOutDunningDialog";
import { useDunningDashboard } from "./DunningDashboard";

export function DunningList({
  filter,
  header,
  useGlobalCandidateQueries = false,
}: {
  filter: { drivingSchoolId?: string; showPostponed: boolean };
  header?: React.ReactNode;
  useGlobalCandidateQueries?: boolean;
}) {
  const { openCancelDunningDialog, cancelDunningStudent, ...cancelDunningDialogProps } =
    useDunningActionDialog("cancelDunning");
  const { openBookOutDunningDialog, bookOutDunningStudent, setBookOutDunningDialogMeta, ...bookOutDunningDiaolgProps } =
    useDunningActionDialog("bookOutDunning");
  const { dashboard, drivingSchoolsById, isLoading } = useDunningDashboard({
    ...filter,
    useGlobalCandidateQueries,
  });

  return (
    <>
      <Board
        title="Mahnwesen"
        subtitle={
          dashboard ? (
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              <Money cents={dashboard.totalAmount} /> offen gesamt
            </Typography>
          ) : undefined
        }
        header={header}
      >
        <DunningColumn
          title="Offene Beträge"
          students={dashboard?.studentsByResource.candidatesForBlocking ?? []}
          drivingSchoolsById={drivingSchoolsById}
          amount={dashboard?.amountByResource.candidatesForBlocking}
          isLoading={isLoading}
        />
        <DunningColumn
          title="Blockiert"
          students={dashboard?.studentsByResource.candidatesForFirstDunningNotice ?? []}
          drivingSchoolsById={drivingSchoolsById}
          amount={dashboard?.amountByResource.candidatesForFirstDunningNotice}
          isLoading={isLoading}
          actions={[
            <BookOutButton
              onClick={(student, invoices) => {
                setBookOutDunningDialogMeta({ invoices });
                openBookOutDunningDialog(student);
              }}
            />,
            <CancelDunningProcessButton onClick={openCancelDunningDialog} />,
          ]}
        />
        <DunningColumn
          title="1. Mahnung"
          students={dashboard?.studentsByResource.candidatesForSecondDunningNotice ?? []}
          drivingSchoolsById={drivingSchoolsById}
          amount={dashboard?.amountByResource.candidatesForSecondDunningNotice}
          isLoading={isLoading}
          actions={[
            <BookOutButton
              onClick={(student, invoices) => {
                setBookOutDunningDialogMeta({ invoices });
                openBookOutDunningDialog(student);
              }}
            />,
            <CancelDunningProcessButton onClick={openCancelDunningDialog} />,
          ]}
        />
        <DunningColumn
          title="2. Mahnung"
          students={dashboard?.studentsByResource.candidatesForHandoverToPairFinance ?? []}
          drivingSchoolsById={drivingSchoolsById}
          amount={dashboard?.amountByResource.candidatesForHandoverToPairFinance}
          isLoading={isLoading}
          actions={[
            <BookOutButton
              onClick={(student, invoices) => {
                setBookOutDunningDialogMeta({ invoices });
                openBookOutDunningDialog(student);
              }}
            />,
            <CancelDunningProcessButton onClick={openCancelDunningDialog} />,
          ]}
        />
        <DunningColumn
          title="Inkasso"
          students={dashboard?.studentsByResource.studentsHandedOverToPairFinance ?? []}
          drivingSchoolsById={drivingSchoolsById}
          amount={dashboard?.amountByResource.studentsHandedOverToPairFinance}
          isLoading={isLoading}
          actions={[<CancelDunningProcessButton onClick={openCancelDunningDialog} />]}
        />
      </Board>
      {cancelDunningStudent && (
        <CancelDunningProcessDialog student={cancelDunningStudent} {...cancelDunningDialogProps} />
      )}
      {bookOutDunningStudent && <BookOutDunningDialog student={bookOutDunningStudent} {...bookOutDunningDiaolgProps} />}
    </>
  );
}
